var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "12px",
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign-in",
    transform: "translate(-839.000000, -381.000000)",
    fill: "#A3AEBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_ice",
    transform: "translate(838.000000, 377.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.08125,13.925 C12.2895833,13.925 14.08125,12.1333333 14.08125,9.925 C14.08125,7.725 12.2895833,5.925 10.08125,5.925 C7.88125,5.925 6.08125,7.725 6.08125,9.925 C6.08125,12.1333333 7.88125,13.925 10.08125,13.925 Z M18.3645833,9.425 C18.5479167,9.76666667 18.5479167,10.1833333 18.3645833,10.5166667 C16.68125,13.5583333 13.7395833,15.6916667 10.0479167,15.6916667 C6.52291667,15.6916667 3.58958333,13.4908333 1.82291667,10.475 C1.61458333,10.1166667 1.61458333,9.66666667 1.82291667,9.30833333 C3.58958333,6.325 6.50625,4.16666667 10.00625,4.16666667 C13.73125,4.16666667 16.6979167,6.34166667 18.3645833,9.425 Z M12.9145,9.92516667 C12.9145,11.4918333 11.6478333,12.7576667 10.0811667,12.7576667 C8.52283333,12.7576667 7.24783333,11.4918333 7.24783333,9.92516667 C7.24783333,8.36683333 8.52283333,7.09183333 10.0811667,7.09183333 C11.6478333,7.09183333 12.9145,8.36683333 12.9145,9.92516667 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/ic_eye.7a24d54c.svg";
export { ForwardRef as ReactComponent };